module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": require("assets/images/vti.png"),
      "alt": _vm.description
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a97aea1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 372
// module chunks = 66